import { RequirementEvidenceCategoryParams, RequirementCategoryType } from '@/backend/access/requirementEvidenceCategory/types';

export class RequirementEvidenceCategory {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  requirementId: string;
  name: string;
  description?: string | null;
  type: RequirementCategoryType;

  constructor(params: RequirementEvidenceCategoryParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.requirementId = params.requirementId;
    this.name = params.name;
    this.description = params.description;
    this.type = params.type;
  }
}
